import domReady from '@wordpress/dom-ready';

/**
 * Highlights the "App Integrations" submenu item based on the current URL.
 */
class MenuHighlighter {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		this.page = 'uncanny-automator-config';
		this.tab = 'premium-integrations';

		// Since there's no specific ID for each submenu, we need to start from the parent menu item
		this.parentMenuItemSelector = '.wp-has-current-submenu.wp-menu-open.menu-top.menu-icon-uo-recipe';
		this.submenuSelector = 'ul.wp-submenu li a';

		if ( this.shouldHighlightMenuItem() ) {
			this.highlightMenuItem();
		}
	}

	/**
	 * Determines if the current URL matches the criteria to highlight the menu item.
	 *
	 * @return {Boolean} True if the menu item should be highlighted.
	 */
	shouldHighlightMenuItem() {
		const urlParams = new URLSearchParams( window.location.search );
		return urlParams.get( 'page' ) === this.page && urlParams.get( 'tab' ) === this.tab;
	}

	/**
	 * Adds the necessary classes to highlight the menu item.
	 */
	highlightMenuItem() {
		const parentMenuItem = document.querySelector( this.parentMenuItemSelector );
		const submenuItems = parentMenuItem ? parentMenuItem.querySelectorAll( this.submenuSelector ) : [];
		submenuItems.forEach( ( item ) => {
			if ( item.href.includes( `page=${this.page}&tab=${this.tab}` ) ) {
				// First, remove any existing highlights
				document.querySelectorAll( '#adminmenu li' ).forEach( li => {
					const link = li.querySelector( 'a' );
					if ( link ) {
						link.classList.remove( 'current' );
					}
					li.classList.remove( 'current' );
				} );

				// Then, highlight the matching submenu item and its parent menu
				item.classList.add( 'current' );
				item.parentNode.classList.add( 'current' ); // Highlight the li element
			}
		} );
	}
}

// Invoke classes when the DOM is ready
domReady( () => {
	new MenuHighlighter();
} );